// extracted by mini-css-extract-plugin
export var footer = "FooterTemplate-module--footer--6414a";
export var linksContainer = "FooterTemplate-module--linksContainer--944dc";
export var list = "FooterTemplate-module--list--0df1a";